import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";


import LoginForm from "./components/LoginForm";
import SocialLogin from "./components/SocialLogin";

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 flex items-center justify-center p-4">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-teal-700/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Logo / Brand */}
        <div className="text-center mb-8">
          <Link to="/landing-page" className="inline-flex items-center gap-3 group">
            <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-200">
              <Icon name="Zap" size={24} color="#FFFFFF" strokeWidth={2.5} />
            </div>
            <span className="text-2xl font-bold text-white font-heading">
              Fit<span className="text-teal-400">Pulse</span>
            </span>
          </Link>
          <p className="mt-3 text-slate-400 text-sm font-body">Gym Management Platform</p>
        </div>

        {/* Card */}
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-white font-heading">Welcome back</h1>
            <p className="text-slate-400 text-sm mt-1 font-body">Sign in to your gym dashboard</p>
          </div>

          <LoginForm />

          {/* <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-white/10" />
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="bg-transparent px-3 text-slate-500 font-caption">or continue with</span>
            </div>
          </div> */}

          {/* <SocialLogin /> */}

          <p className="text-center text-sm text-slate-400 mt-6 font-body">
            Don't have an account?{" "}
            <Link to="/registration-page" className="text-teal-400 hover:text-teal-300 font-medium transition-colors">
              Create one free
            </Link>
          </p>
        </div>

        <p className="text-center text-xs text-slate-600 mt-6 font-caption">
          © 2026 myfitnesstracking. All rights reserved.
        </p>
      </div>
    </div>
  );
}
